import { render, staticRenderFns } from "./VenueAvailabilityBadge.vue?vue&type=template&id=4b5c7332&"
import script from "./VenueAvailabilityBadge.vue?vue&type=script&lang=js&"
export * from "./VenueAvailabilityBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports